export type PlayPlacement = "android_hero" | "android_footer" | "home" | "footer";

/** Fixed campaign values only: never propagate user URLs or chart/birth data. */
export function playStoreUrl(placement: PlayPlacement): string {
  const url = new URL("https://play.google.com/store/apps/details");
  url.searchParams.set("id", "com.astrogenesis.mobile");
  url.searchParams.set("utm_source", "astrogenesis_website");
  url.searchParams.set("utm_campaign", "android_organic");
  url.searchParams.set("utm_content", placement);
  return url.toString();
}
